module.exports = __webpack_public_path__ + "static/media/Gallery-15.903a73cc.jpg";